import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@glu/form-components';
import { FormContext } from '@glu/validation-react';
import { withStyles } from '@glu/theming';

import ContrastCheck from '../ContrastCheck/ContrastCheck';
import styles from './StyleInput.styles';
import Popover from '../Popover/Popover';

const StyleInput = ({
  classes,
  name,
  labelText,
  type,
  placeholder,
  tooltip,
  displayText,
  backgroundColor,
  color,
  fontSize,
  fontWeight
}) => {
  const { data, onChange } = useContext(FormContext);
  const value = data[name] || '';
  const isPixel = type === 'pixel';
  const onChangeCallback = useCallback((e) => {
    onChange(name, isPixel ? `${e.target.value}px` : e.target.value);
  }, [name, onChange, isPixel]);

  const valueMemo = useMemo(() => (isPixel ? parseInt(value, 10) : value) || '', [value, isPixel]);

  return (
    <div className={classes.root}>
      <div className={classes.inputWrapper}>
        <Input
          name={name}
          labelText={labelText}
          value={valueMemo}
          onChange={onChangeCallback}
          placeholder={placeholder}
          disableInputAPI
        />
        {displayText && <p className={classes.display}>{displayText}</p>}
      </div>
      <ContrastCheck
        color={color}
        backgroundColor={backgroundColor}
        fontSize={fontSize}
        fontWeight={fontWeight}
      />
      {tooltip && (
        <Popover>
          {tooltip}
        </Popover>
      )}
    </div>
  );
};

StyleInput.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  displayText: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /* eslint-disable react/no-unused-prop-types */
  // used by style functions
  borderRadius: PropTypes.number,
  borderColor: PropTypes.string,
  textDecoration: PropTypes.string
};

StyleInput.defaultProps = {
  placeholder: '',
  tooltip: null,
  displayText: null,
  type: undefined,
  color: undefined,
  backgroundColor: undefined,
  fontSize: undefined,
  fontWeight: undefined,
  borderRadius: 0,
  borderColor: '#CCC',
  textDecoration: null
};

export default withStyles(styles)(StyleInput);
